import { Tooltip } from 'bootstrap';

const searchModal = document.getElementById('search-modal');
if (searchModal) {
    searchModal.addEventListener('shown.bs.modal', () => {
        const searchInput = searchModal.querySelector('input');
        if (searchInput) {
            searchInput.focus();
        }
    });
}

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
if (tooltipTriggerList) {
    tooltipTriggerList.forEach(function(tooltipTriggerEl) {
        new Tooltip(tooltipTriggerEl);
    });
}
